import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentLogoCarousel } from '../../components/SectionContentLogoCarousel'

const logos = [
  {
    companyName: 'Mellow Mushroom',
    publicId: 'logos/logo-restaurant-mellow-mushroom',
  },
  { companyName: 'Taco Boy', publicId: 'logos/logo-restaurant-tacoboy' },
  {
    companyName: 'Serena Pastificio',
    publicId: 'logos/logo-restaurant-serena',
  },
  { companyName: "Marlow's Tavern", publicId: 'logos/logo-restaurant-marlows' },
  {
    companyName: "Rosemary's Catering",
    publicId: 'logos/logo-catering-rosemarys-catering',
  },
  { companyName: 'IPIC', publicId: 'logos/logo-catering-fsg-ipic' },
  { companyName: 'Aramark', publicId: 'logos/logo-catering-fsg-aramark' },
  {
    companyName: 'Oak View Group',
    publicId: 'logos/logo-catering-fsg-oak-view-group',
  },
  { companyName: 'Southern', publicId: 'logos/logo-catering-fsg-southern' },
  {
    companyName: 'PGA Ocean Course',
    publicId: 'logos/logo-catering-event-pga',
  },
  {
    companyName: 'Credit One Stadium',
    publicId: 'logos/logo-catering-fsg-creditone',
  },
  {
    companyName: 'Moody Center',
    publicId: 'logos/logo-catering-event-moody-center',
  },
  {
    companyName: 'The Pines at Davidson',
    publicId: 'logos/logo-catering-the-pines',
  },
  { companyName: 'La Pera', publicId: 'logos/logo-catering-la-pera' },
  {
    companyName: 'Austin Country Club',
    publicId: 'logos/logo-catering-event-austin-country-club',
  },
].map(({ companyName, publicId }) => ({
  companyName,
  image: { publicId, alt: `${companyName} logo` },
}))

export const SectionContentInstanceMaraLogoCarousel: React.FunctionComponent =
  () => (
    <Section
      backgroundColor="white"
      padding={100}
      constrainWidth={false}
      prerender
    >
      <SectionContentLogoCarousel
        heading="Mara powers staffing for hospitality’s largest players in 45+ cities and counting"
        logos={logos}
      />
    </Section>
  )
